module.exports = __webpack_public_path__ + "static/trust.934af8c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trust.png
// module id = 487
// module chunks = 59963396046441